import React from 'react'
import NotificationContent from 'Components/Notifications/NotificationContent'

function ProfNotificationInsideContent({attorney, setLoadNotification}) {
  return (
    <div className='flex w-full flex-col font-plexsans' style={{ background: '#f7f4ed' }}>
      <div className='w-full px-5 py-6 lg:px-8 lg:py-8'>
        <NotificationContent attorney={attorney} setLoadNotification={setLoadNotification} leaveTopText={true}/>
      </div>
    </div>
  )
}

export default ProfNotificationInsideContent
